import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import EntryPoint from "../../../pages/settings/termsConditionReport";
import { TermsConditionReportContainerProps } from "../../../interfaces/containers";
import {
    generateTermsConditionReport,
    checkTermsConditionReport,
    cleanTermsConditionReport
} from "../../../actions/termsConditionReport";

function mapStateToProps(state: TermsConditionReportContainerProps) {
    return {
        termsConditionReport: state.termsConditionReport
    };
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        generateTermsConditionReport,
        checkTermsConditionReport,
        cleanTermsConditionReport
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(EntryPoint);
